import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
import { Core } from "../helpers/core";
import { AppIcons } from "../constants/app-icons";
import { nextOccurrenceCell, recurringMarkerCell } from "../helpers/schedule-column";
import { DOMAIN } from "./domain-constant";
import { Money } from "../helpers/money";
export default class JournalService extends ApiService {
  namespace = "journal";
  id = true;
  template = "defaultTemplate";
  icon = "Spreadsheet";
  DOMAIN = DOMAIN.JOURNAL_ENTRY;
  listingRelations = "schedulars,schedules,nextOccurrence";
  relations =
  "?expand=entries.entity,files,files.file,schedulars,schedules,nextOccurrence&is_template=1";
  data = [];
  favicon = "ApplicationForm";
  name = "Journal Entry";
  Width = 1200;
  enableSchedular = true;
  useNextNumber = true;
  showLeftBar = false;
  listingLazyParams = { is_template: 0 };
  singular = this.terminology.journalEntry.singular;
  plural = this.terminology.journalEntry.plural;
  labelKey = "number";
  gemItems = [
    {
      key: "create",
      label: this.t("addAEntity", { entity: "Journal Entry" }),
      icon: AppIcons.PLUS,
    },

    {
      key: "listing",
      label: this.t("allEntity", { entity: "Entries" }),
      icon: AppIcons.BULLETS,
    },
  ];

  columns = [
    {
      header: "",
      field: "recurring_id",
      width: "2",
      template: (data) => recurringMarkerCell(data),
    },
    {
      header: this.t("number"),
      icon: AppIcons.SHRED,
      field: "number",
    },
    {
      header: this.t("date"),
      icon: AppIcons.CALENDAR,
      field: "date",
      template: (data) => {
        return Core.datey(data.date);
      },
    },
    {
      header: this.t("amount"),
      icon: AppIcons.MONEY,
      field: "amount",
      template: (data) => {
        return Money.format(data.amount);
      },
    },
    {
      header: "AJE",

      field: "aje",
      template: (data) => {
        if (data.is_adjusting === 1) {
          return "Yes";
        } else return "";
      },
      width: "3",
    },
    {
      icon: AppIcons.NOTEBOOK,
      field: "draft",
      width: "3",
      template: (data) => {
        return data.is_draft === 1 ? "Yes" : "";
      },
    },
    {
      header: this.t("nextOccurrence"),
      icon: AppIcons.REPEAT,
      field: "nextOccurrence",
      template: (data) => nextOccurrenceCell(data),
    },
  ];

  navItems = [
    {
      key: "listing",
      label: this.t("viewAllEntities", { entity: this.plural }),
      icon: AppIcons.BULLETS,
    },
    {
      key: "bookmark",
      label: this.t("viewMyBookmarks", { entity: this.singular }),
      icon: AppIcons.BOOKMARK,
    },
    {
      key: "draft",
      label: this.t("viewEntity", { entity: this.t("draft") }),
      icon: AppIcons.DOCUMENT_WITH_TEXT,
    },
    {
      key: "template",
      label: this.t("viewEntity", { entity: this.t("Template") }),
      icon: AppIcons.TEMPLATE,
    },
  ];
  listMenuItems = [
    {
      key: "edit",
      label: this.t('editThisEntity', { entity: this.singular }),
      icon: AppIcons.EDIT,
    },
    {
      key: "announce",
      label: this.t('announceThisEntity', { entity: this.singular }),
      services: -3,
      icon: AppIcons.ANNOUNCEMENT,
    },
    {
      key: "email",
      label: this.t('emailThisEntity', { entity: this.singular }),
      services: 208,
      icon: AppIcons.MAIL,
    },
    {
      key: "bookmark",
      label: this.t('bookmarkThisEntity', { entity: this.singular }),
      icon: AppIcons.BOOKMARK,
    },
    {
      key: "viewJournal",
      label: this.t('viewjournal'),
      icon: AppIcons.JOURNAL_VIEW,
    },
  ];
  templateActionMenuItems = [
    {
      key: "edit",
      label: "Edit Template",
      icon: AppIcons.EDIT,
    },
    {
      key: "announce",
      label: "announceThisEntity",
      services: -3,
      icon: AppIcons.ANNOUNCEMENT,
    },
    {
      key: "email",
      label: "emailThisEntity",
      services: 208,
      icon: AppIcons.MAIL,
    },
  ];
  getActionMenu(item) {
    if (item && item.is_template == 1) {
      return this.templateActionMenuItems;
    }
    return this.listMenuItems;
  }
  prepareTemplateListing() {
    this.listMenuItems = this.templateActionMenuItems;
    return this;
  }
  menuItems = [
    {
      label: this.t("openThisEntity", { entity: this.name }) + "...",
      icon: "pi pi-book",
      command: () => {},
    },
    {
      label: this.t("announceThisEntity", { entity: this.name }) + "...",

      icon: "pi pi-volume-up",
      command: () => {},
    },
    {
      label: this.t("emailThisEntity", { entity: this.name }) + "...",
      icon: "pi pi-envelope",
      command: () => {},
    },
    {
      label: this.t("bookmarkThisEntity", { entity: this.name }) + "...",
      icon: "pi pi-bookmark",
      command: () => {},
    },
    {
      label: this.t("viewEntity", { entity: this.name }),
      icon: "pi pi-credit-card",
      command: () => {
        alert("add to bookmark");
      },
    },
  ];
  listMenu = [
    {
      key: "create",
      label: this.t("updateEntity", { entity: this.name }),
      icon: PrimeIcons.LIST,
    },
    {
      key: "create",
      label: this.t("listMenu.announceThis") + " Journal Entry",
      service: -3,
      icon: PrimeIcons.LIST,
    },
    {
      key: "create",
      label: this.t("listMenu.emailThis") + " Journal Entry",
      icon: PrimeIcons.LIST,
    },
    {
      key: "create",
      label: this.t("listMenu.bookmarkThis") + " journal entry",
      icon: PrimeIcons.LIST,
    },
    {
      key: "listing",
      label: this.t("viewEntity", { entity: "Journal" }),
      service: -4,
      icon: PrimeIcons.LIST,
    },
  ];
  gemMenuItems = [
    {
      key: "create",
      label: "Journal Entry",
      services: 174,
      icon: AppIcons.CLOCK,
    },
    {
      key: "create",
      label: "Journal Entry Template",
      services: 174,
      type: "template",
      icon: AppIcons.BULLETS,
    },
    {
      key: "load-template",
      label: "Load Template",
      services: 174,
      width: 450,
      icon: AppIcons.FOLDER_HORIZONTAL_CLOSED,
    },
  ];
  // create/new mode "More..." menu
  moreItems = [
    {
      key: "reminder",
      label: "Add a Reminder...",
      icon: AppIcons.CLOCK,
    },
    {
      key: "recurring",
      label: "Make Recurring...",
      icon: AppIcons.CALENDAR,
    },
    {
      key: "saveTemplate",
      label: "Save Copy as Template...",
      icon: AppIcons.BOOK_OPEN,
    },
    {
      key: "loadTemplate",
      label: "Load Template...",
      icon: AppIcons.FOLDER_HORIZONTAL_CLOSED,
    },
  ];
  // edit mode "More..." menu
  editMoreItems = [
    {
      key: "reminder",
      label: "Add a Reminder...",
      icon: AppIcons.CLOCK,
    },
    {
      key: "recurring",
      label: "Make Recurring...",
      icon: AppIcons.CALENDAR,
    },
    {
      key: "saveTemplate",
      label: "Save Copy as Template...",
      icon: AppIcons.BOOK_OPEN,
    },
    {
      key: "copy",
      label: "Copy this Transaction...",
      icon: AppIcons.COPY,
    },
    {
      key: "reverse",
      label: "Create Reverse Transaction...",
      icon: AppIcons.REPLY,
    },
    {
      key: "void",
      label: "Void this Transaction...",
      icon: AppIcons.BAN,
    },
    {
      key: "delete",
      label: "Delete this Transaction...",
      icon: AppIcons.TRASH,
    },
  ];
  filterItems = [{ name: "Date", value: "2" }];

  constructor() {
    // TODO(template-endpoint): confirm whether Journal Entry Templates are saved
    // on the same "journal-entries" endpoint (is_template / template_name fields)
    // or on a dedicated endpoint. Listing/opening/saving templates below relies
    // on is_template filtering of journal-entries for now.
    super("journal-entries");
  }
}
